import { Flex, Tooltip } from '@chakra-ui/react';
import { InfoCircleOutline } from '@aslanpay/portal-common-lib';

interface FieldHelpProps {
  /** What the help is about, used to name the trigger for screen readers. */
  subject: string;
  help: string;
  testId: string;
}

function FieldHelp({ subject, help, testId }: FieldHelpProps) {
  return (
    <Tooltip hasArrow shouldWrapChildren arrowPadding={0} placement="top" label={help} maxW="320px">
      <Flex
        as="button"
        type="button"
        aria-label={`What ${subject} means`}
        onClick={(event) => event.preventDefault()}
        data-testid={testId}
      >
        <InfoCircleOutline boxSize="16px" color="brand.darkGray" cursor="pointer" />
      </Flex>
    </Tooltip>
  );
}

export default FieldHelp;
